<div class="loading-spinner">
    <img class="spinner-img" src="/assets/images/loaders/loading-spinner.png" alt="spinner.svg">
    <label>{{label}}</label>
</div>